import { render, staticRenderFns } from "./DestinationView.vue?vue&type=template&id=9c2f4d70&scoped=true&"
import script from "./DestinationView.vue?vue&type=script&lang=ts&"
export * from "./DestinationView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2f4d70",
  null
  
)

export default component.exports